module.exports = {"360821001":"高新街道","360821002":"金鸡湖街道","360821100":"敦厚镇","360821101":"永阳镇","360821102":"天河镇","360821103":"横江镇","360821104":"固江镇","360821105":"万福镇","360821106":"永和镇","360821107":"桐坪镇","360821108":"凤凰镇","360821109":"油田镇","360821110":"敖城镇","360821111":"梅塘镇","360821112":"浬田镇","360821200":"北源乡","360821201":"大冲乡","360821204":"登龙乡","360821205":"安塘乡","360821206":"官田乡","360821207":"指阳乡","360821400":"吉安高新技术产业园区","360821401":"井冈山经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360821.json
// module id = 1206
// module chunks = 0